import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { usePrismicDocumentByUID } from "@prismicio/react";
import ArtistPage from "./pages/ArtistPage";
import MainPage from "./pages";

import Snow from "./components/Snow";

import "./App.scss";

const CUSTOM_UID = "loveweek";

const App = () => {
  const [document] = usePrismicDocumentByUID("concours", "loveweek");
  const [artistsData, setArtistsData] = useState(null);
  const [globalData, setGlobalData] = useState(null);

  useEffect(() => {
    if (document && document.data && !artistsData) {
      setArtistsData(document.data.artist);
      setGlobalData(document.data);
    }
  }, [document]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          {artistsData &&
            artistsData
              .map((el) => CUSTOM_UID + "/" + el.path[0].text)
              .map((path, index) => {
                return (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <ArtistPage
                        CUSTOM_UID={CUSTOM_UID}
                        globalData={globalData}
                        index={index}
                        document={document}
                        artistsData={artistsData}
                      />
                    }
                  />
                );
              })}
          <Route
            path="*"
            element={
              <MainPage
                CUSTOM_UID={CUSTOM_UID}
                document={document}
                artistsData={artistsData}
                globalData={globalData}
              />
            }
          />
        </Routes>
      </BrowserRouter>
      {globalData && globalData.showsnow && <Snow />}
    </>
  );
};

export default App;
